// extracted by css-extract-rspack-plugin
module.exports =  {"headerName":"ManageSkillsDialog__headerName___GNaas","tabButton":"ManageSkillsDialog__tabButton___fKLQq"};